<template>
  <LayoutBase>
    <BasicAppHeader />

    <v-layout class="overflow-inherit!" style="z-index: inherit">
      <v-main :class="{ 'pt-30! pb-12!': !noPad }">
        <slot />
      </v-main>
    </v-layout>

    <DefaultAppFooter />

    <div class="md:hidden">
      <MobileNavFooter />
    </div>
  </LayoutBase>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  LayoutBase,
  BasicAppHeader,
  DefaultAppFooter,
  MobileNavFooter,
} from "~/components/layout";

export default defineComponent({
  components: {
    LayoutBase,
    BasicAppHeader,
    DefaultAppFooter,
    MobileNavFooter,
  },
  setup() {
    const route = useRoute();
    const noPad = computed(() => route.meta.noAppHeaderPadding);

    return {
      noPad,
    };
  },
});
</script>
